import { render, staticRenderFns } from "./schedule-config.vue?vue&type=template&id=2ec4988a&scoped=true"
import script from "./schedule-config.vue?vue&type=script&lang=js"
export * from "./schedule-config.vue?vue&type=script&lang=js"
import style0 from "./schedule-config.vue?vue&type=style&index=0&id=2ec4988a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec4988a",
  null
  
)

export default component.exports